import React, { Component } from 'react';

class RepoDesignCardImageWithCount extends Component {
  render() {

      return (
        <div>
        	<div className="repo-index-design-img-parent m-0 p-0">
      	     <img className="image repo-index-design-inside-div" src={this.props.image} alt="design" />
          </div>
          <span className="repo-index-design-new-images-count"> {this.props.count}</span>
        </div>
      )
  }
}

export default RepoDesignCardImageWithCount
